/**
 * Estate media header — background parallax
 *
 * The media wrapper sits inside [data-estate-header] and extends 20% beyond
 * the container's top and bottom edges (set via inline style in the template).
 * On scroll we apply a gentle translateY so the background moves at ~15% of
 * the scroll speed, making it appear to lag behind the page and creating depth.
 *
 * The overlay and heading/buttons are siblings of the media wrapper, so they
 * stay fixed relative to the container and are unaffected by the transform.
 */

// The bundle is loaded async so DOMContentLoaded may have already fired by the
// time this script executes. Use the readyState check so we initialise
// immediately if the DOM is already available, or wait if it isn't.
function initEstateHeaderParallax() {
    var header = document.querySelector('[data-estate-header]');
    if (!header) return;

    var mediaLayer = header.querySelector('[data-parallax-media]');
    if (!mediaLayer) return;

    // Promote to its own compositor layer for smooth GPU-driven animation
    mediaLayer.style.willChange = 'transform';

    var ticking = false;

    function update() {
        var rect = header.getBoundingClientRect();

        // Skip work once the header has fully scrolled out of view
        if (rect.bottom < 0) {
            ticking = false;
            return;
        }

        // scrollY grows as the user scrolls down. Shifting the media layer DOWN
        // by 15% of that distance makes it appear to move UP more slowly than
        // the rest of the page — the classic parallax illusion.
        var offset = window.scrollY * 0.15;
        mediaLayer.style.transform = 'translateY(' + offset + 'px)';

        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });

    // Apply initial position immediately (handles page-restore scroll position)
    update();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEstateHeaderParallax);
} else {
    initEstateHeaderParallax();
}
